// Modules
import React, { useEffect,useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

// Styled Components
import { BackgroundView, Container, H1, Group, PastButton } from './events.styles';
import { MarginBottom } from '../styles/common/space.styles';

// Components
import HighlightEvent from '../components/highlight-event/highlight-event';
import EventList from '../components/event-list/event-list.compoent';
import Filters from '../components/filters/filters.component';
import LoadMore from '../components/load-more/load-more.component';

// Constant
import { constant } from '../constants/contant';

// Selectors
import { capitalizedLang } from '../selectors/common.selector';

const EventScreen = () => {
	const lang = useSelector((state: any) => capitalizedLang()(state));
	const nextPage = useSelector((state: any) => state.event.nextPage);
	const loading = useSelector((state: any) => state.event.loading);
	const dir = useSelector((state: any) => state.common.dir);
	const location = useLocation();
	const history = useHistory();
	const params: any = useParams();
	const [label, setLabel] = useState('');
	const [title,setTitle] = useState('');

	const toPast = () => {
		const unit = params?.organizingUnit ? 
		`/${params?.organizingUnit}` : '';
		
		if (location.pathname.includes('past')){
			history.replace(
				`${location?.pathname.replace(`/past${unit}`, unit)}`
			);
		} else {
			history.push(
				`${location?.pathname.replace(unit, '')}/past${unit}`
			);
		}
	}

	useEffect(() => {
		// if (!location.search.includes('endDate') && location.pathname.includes('past')) {
		// 	history.push(`${location?.pathname}?endDate=${moment().unix()}`);		
		// }
		// if (!location.search.includes('startDate') && !location.pathname.includes('past')) {
		// 	history.push(`${location?.pathname}?startDate=${moment().unix()}`);
		// }

	}, []);

	useEffect(()=>{
		if (location.pathname.includes('past')){
			setTitle(constant[lang].VARIABLES.PAST_EVENTS);
			setLabel(constant[lang].VARIABLES.TO_ACTIVE);
		} else{
			setTitle(constant[lang].VARIABLES.EVENTS);
			setLabel(constant[lang].VARIABLES.TO_PAST);
		}
	},[location,lang])

	// if (loading) {
	// 	return <Loading />;
	// }

	return (
		<BackgroundView>
			<Container>
				<Group>
					<h1>{title}</h1>
					{
						!loading && 
						<PastButton
							direction={dir}
							label={label}
							icon={false}
							onBiuOnClick={toPast}
						/>
					}
					
				</Group>
				<MarginBottom size={48} />
				<HighlightEvent />
				<Filters />
				<EventList />
				{nextPage && !loading && <LoadMore />}
			</Container>
		</BackgroundView>
	);
};

export default EventScreen;
